import { ActionTree } from 'vuex'
import { RootState } from '@/store'
import { ProjectAPI } from '@/api/backend-client'
import { ProjectsState } from '@/store/projects'

export const actions: ActionTree<ProjectsState, RootState> = {
    async fetchData({ getters, commit }): Promise<void> {
        try {
            commit('fetchData')
            commit('fetchDataSuccess', await ProjectAPI.getPaged(getters.requestParams))

        } catch (error) {
            commit('fetchDataFailure', error)
        }
    },

    async setPage({ commit, dispatch }, payload: { page: number }): Promise<void> {
        commit('setPage', payload)
        dispatch('fetchData')
    },

    async nextPage({ state, commit, dispatch }): Promise<void> {
        commit('setPage', { page: state.page + 1 })
        dispatch('fetchData')
    },

    async prevPage({ state, commit, dispatch }): Promise<void> {
        commit('setPage', { page: state.page - 1 })
        dispatch('fetchData')
    },

    async applyOrder({ commit, dispatch }, payload: { field: string, direction: string }): Promise<void> {
        commit('applyOrder', payload)
        commit('setPage', { page: 1 })
        dispatch('fetchData')
    },

    async applyActiveFilter({ commit, dispatch }, payload: { priorityFilter: number[] }): Promise<void> {
        commit('applyActiveFilter', payload)
        commit('setPage', { page: 1 })
        dispatch('updateMenuCount')
        dispatch('fetchData')
    },

    async applyCompanyFilter({ commit, dispatch }, payload: { query: string }): Promise<void> {
        commit('applyCompanyFilter', payload)
        commit('setPage', { page: 1 })
        dispatch('fetchData')
    },

    async applyNameFilter({ commit, dispatch }, payload: { query: string }): Promise<void> {
        commit('applyNameFilter', payload)
        commit('setPage', { page: 1 })
        dispatch('fetchData')
    },

    async resetFilters({ commit, dispatch }): Promise<void> {
        commit('resetFilters')
        commit('setPage', { page: 1 })
        dispatch('updateMenuCount')
        dispatch('fetchData')
    },
}
